webpackJsonp([24],{

/***/ "SWC/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-terms-and-conditions"},[(!_vm.isComponentReady)?_c('div',{staticClass:"page-terms-and-conditions__content"},[_c('br'),_vm._v(" "),_c('static-page-loader')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"page-terms-and-conditions__content",domProps:{"innerHTML":_vm._s(_vm.content)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pMeB":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ycOt");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("798fa5b5", content, true, {});

/***/ }),

/***/ "v+Mv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_terms_and_conditions_js__ = __webpack_require__("xqHz");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72ec6584_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_terms_and_conditions_vue__ = __webpack_require__("SWC/");
function injectStyle (ssrContext) {
  __webpack_require__("pMeB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_terms_and_conditions_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72ec6584_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_terms_and_conditions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "xqHz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_index__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_scrollTo__ = __webpack_require__("rrO7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_app_app_modals_modals_constants__ = __webpack_require__("Rjwe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_cmsContent__ = __webpack_require__("tQfv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_static_page_header_static_page_header_vue__ = __webpack_require__("Zdl7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_seoMeta__ = __webpack_require__("08z+");













var toRoute = '';
var restore = true;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_cmsContent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__mixins_seoMeta__["a" /* default */]],
  components: {
    staticPageHeader: __WEBPACK_IMPORTED_MODULE_10__components_static_page_header_static_page_header_vue__["a" /* default */]
  },
  metaInfo: function metaInfo() {
    return this.buildSeoMeta({
      title: 'Terms and Conditions'
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['isLayoutMobile'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('browse', ['getStaticPageFull'])),
  created: function created() {
    var _this = this;

    this.loaderAdd(document.body);
    this.getStaticPageFull(__WEBPACK_IMPORTED_MODULE_6__constants__["d" /* STATIC_PAGES */].TERMS).then(function (data) {
      _this.isComponentReady = true;
      _this.installDynamicControls({ data: data });
    }).then(function () {
      return _this.loaderRemove(document.body);
    }).then(function () {
      var query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["I" /* parseQuery */])(window.location.search);
      if (query && query.section) {
        _this.$nextTick(function () {
          var toWhere = document.getElementById(query.section);
          if (!toWhere) {
            return;
          }
          var topOffset = 16; // add some padding
          var header = document.querySelector('.app-layout__header');
          if (header) {
            topOffset += header.offsetHeight;
          }
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_scrollTo__["a" /* default */])(toWhere, 0, 'linear', null, topOffset);
        });
      }
    }).catch(function () {
      return _this.loaderRemove(document.body);
    });
  },

  // beforeDestroy() {
  //   // firest after router loop
  //   if (restore) {
  //     store.dispatch('popup/restorePopup', toRoute);
  //   }
  // },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var popup = to.params.noPopup ? null : null;
    __WEBPACK_IMPORTED_MODULE_2__store_index__["a" /* default */].dispatch('popup/rememberPopup', {
      route: from.name,
      popup: popup
    });
    next();
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    // fires before router loop closes popup
    restore = to.name !== 'privacy-policy';
    toRoute = to.name;
    next();
  }
});

/***/ }),

/***/ "ycOt":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, "@-webkit-keyframes pulse{0%{-webkit-transform:scale(1);transform:scale(1);opacity:.6}50%{-webkit-transform:scale(1.0125);transform:scale(1.0125);opacity:.3}to{-webkit-transform:scale(1.025);transform:scale(1.025);opacity:0}}@keyframes pulse{0%{-webkit-transform:scale(1);transform:scale(1);opacity:.6}50%{-webkit-transform:scale(1.0125);transform:scale(1.0125);opacity:.3}to{-webkit-transform:scale(1.025);transform:scale(1.025);opacity:0}}@media screen and (min-width:56.875em){.page-terms-and-conditions{padding:18px 0 0}}.page-terms-and-conditions__header{margin-bottom:0}.page-terms-and-conditions__content{padding:0 15px;background:#fff;-webkit-box-shadow:0 20px 50px 0 rgba(0,0,0,.1);box-shadow:0 20px 50px 0 rgba(0,0,0,.1)}.page-terms-and-conditions__headline{text-align:center}.page-terms-and-conditions__emp{font-size:18px;font-weight:700}", "", {"version":3,"sources":["/home/vsts/work/1/s/src/components/pages/page-terms-and-conditions/page-terms-and-conditions.scss"],"names":[],"mappings":"AACA,yBACA,GACI,2BAA4B,AACpB,mBAAoB,AAC5B,UAAa,CAChB,AACD,IACI,gCAAiC,AACzB,wBAAyB,AACjC,UAAa,CAChB,AACD,GACI,+BAAgC,AACxB,uBAAwB,AAChC,SAAW,CACd,CACA,AACD,iBACA,GACI,2BAA4B,AACpB,mBAAoB,AAC5B,UAAa,CAChB,AACD,IACI,gCAAiC,AACzB,wBAAyB,AACjC,UAAa,CAChB,AACD,GACI,+BAAgC,AACxB,uBAAwB,AAChC,SAAW,CACd,CACA,AAQD,uCACA,2BACI,gBAAkB,CACrB,CACA,AACD,mCACE,eAAiB,CAClB,AACD,oCACE,eAAgB,AAChB,gBAAkB,AAClB,gDAAqD,AAC7C,uCAA6C,CACtD,AACD,qCACE,iBAAmB,CACpB,AACD,gCACE,eAAgB,AAChB,eAAkB,CACnB","file":"page-terms-and-conditions.scss","sourcesContent":["/* stylelint-disable at-rule-no-unknown */\n@-webkit-keyframes pulse {\n0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 0.6;\n}\n50% {\n    -webkit-transform: scale(1.0125);\n            transform: scale(1.0125);\n    opacity: 0.3;\n}\n100% {\n    -webkit-transform: scale(1.025);\n            transform: scale(1.025);\n    opacity: 0;\n}\n}\n@keyframes pulse {\n0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 0.6;\n}\n50% {\n    -webkit-transform: scale(1.0125);\n            transform: scale(1.0125);\n    opacity: 0.3;\n}\n100% {\n    -webkit-transform: scale(1.025);\n            transform: scale(1.025);\n    opacity: 0;\n}\n}\n\n/**\n * Foundation for Sites\n * Version 6.6.3\n * https://get.foundation\n * Licensed under MIT Open Source\n */\n@media screen and (min-width: 56.875em) {\n.page-terms-and-conditions {\n    padding: 18px 0 0;\n}\n}\n.page-terms-and-conditions__header {\n  margin-bottom: 0;\n}\n.page-terms-and-conditions__content {\n  padding: 0 15px;\n  background: white;\n  -webkit-box-shadow: 0 20px 50px 0 rgba(0, 0, 0, 0.1);\n          box-shadow: 0 20px 50px 0 rgba(0, 0, 0, 0.1);\n}\n.page-terms-and-conditions__headline {\n  text-align: center;\n}\n.page-terms-and-conditions__emp {\n  font-size: 18px;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);

// exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/24.a98f920e7b6edf973441.js